import React, { useEffect, useState } from 'react'
import Modal from '../../../../components/Modal'
import LenderUgroService from '../../../../services/lender';
import { toast } from 'react-toastify';

const PayToCustomerModal = ({ toggleModal, state, modalData, leadId, reloadData, paytype, drfData, retryData, transactionData }) => {

    const [custName, setCustName] = useState('');
    const [accNumber, setAccNumber] = useState('');
    const [accType, SetAccType] = useState('');
    const [ifsc, SetIfsc] = useState('');
    const [disbursalAmt, setDisbursalAmt] = useState('')
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)
    const [accNumberList, setAccNumberList] = useState('')

    useEffect(() => {
        if (!accNumberList) {
            setCustName(transactionData?.[0]?.cust_name)
            setAccNumber(transactionData?.[0]?.account_no)
            SetAccType(transactionData?.[0]?.acc_type)
            SetIfsc(transactionData?.[0]?.ifsc)
            setDisbursalAmt(transactionData?.[0]?.disbursal_amt)
        } else {
            let parsedData = drfData?.[accNumberList]
            setCustName(parsedData?.bank_name)
            setAccNumber(parsedData?.bank_acc_id)
            SetAccType(parsedData?.acc_type)
            SetIfsc(parsedData?.ifsc)
            setDisbursalAmt(parsedData?.finance_amount)
        }
    }, [accNumberList])

    useEffect(() => {
        if (Object.entries(retryData)?.length) {
            setCustName(retryData?.cust_name)
            setAccNumber(retryData?.account_no)
            SetAccType(retryData?.account_type)
            SetIfsc(retryData?.ifsc)
            setDisbursalAmt(retryData?.disbursal_amt)
        }
    }, [retryData])

    const formSubmitHandler = async (e) => {
        e.preventDefault();
        setShowConfirmationModal(true)
    }

    const handleConfirmationModal = async (e) => {
        e.preventDefault();
        setLoading(true);
        let payloadData = {
            "lead_id": leadId,
            "cust_name": custName,
            "account_no": accNumber,
            "account_type": accType,
            "ifsc": ifsc,
            "disbursal_amt": disbursalAmt,
            "disbursal_to": paytype == "Bank" ? 1 : 0,
            "ptc_id": retryData?.id || transactionData?.[0]?.id || null
        }
        try {
            let apiResponse;
            apiResponse = await LenderUgroService.savePayToCustomerData(payloadData);
            if (apiResponse?.data?.status?.code === 1) {
                toggleConfirmationModal()
                toggleModal()
                reloadData()
            }
            let success = apiResponse?.data?.messages?.success
            toast.success(success?.form?.[0] || success?.others?.[0]);
            setLoading(false);
        } catch (err) {
            toggleConfirmationModal()
            reloadData()
            setLoading(false);
            let error = err?.response?.data?.messages?.error;
            toast.error(error?.form?.[0] || error?.others?.[0]);
            setErrors(error?.fields);
        }
    }

    const toggleConfirmationModal = () => {
        setShowConfirmationModal(false)
    }

    return (
        <>
            <Modal state={state} closeModal={toggleModal} style={{ width: "400px" }} removeBorderSpace={true}>
                <div className="modal-header-container">
                    <div className="modal-title">{`Pay to ${paytype}`}</div>
                    <div className="closeModalView" onClick={toggleModal}>
                        <span className="closeModalIcon">x</span>
                    </div>
                </div>
                <div className="p-4">
                    <form onSubmit={formSubmitHandler}>
                        <div>
                            {Object.keys(drfData).length > 0 &&
                                <>
                                    <div class='form-group'>
                                        <label>{paytype == "Bank" ? "Select Bank Account Number" : "Select Customer Account Number"}</label>
                                        <div class='row'>
                                            <div class='col-12'>
                                                <select
                                                    class='form-control custom-form-control'
                                                    value={accNumberList}
                                                    onChange={(e) => setAccNumberList(e.target.value)}
                                                >
                                                    <option value="">Please Select</option>
                                                    {Object.keys(drfData)?.map((item) => {
                                                        return <option value={item}>{item}</option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </>
                            }
                            <div class='form-group'>
                                <label>{`${paytype} Name`}</label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <input
                                            class='form-control custom-form-control'
                                            value={custName}
                                            onChange={(e) => setCustName(e.target.value)}
                                            maxLength={50}
                                        />
                                    </div>
                                </div>
                                <tt>
                                    {errors && errors?.cust_name}
                                </tt>
                            </div>
                            <div class='form-group'>
                                <label>{`${paytype} Account Number`}<tt>*</tt></label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <input
                                            class='form-control custom-form-control'
                                            value={accNumber}
                                            onChange={(e) => setAccNumber(e.target.value.replace(/[^0-9]/g, ''))}
                                            maxLength={25}
                                        />
                                    </div>
                                </div>
                                <tt>
                                    {errors && errors?.account_no}
                                </tt>
                            </div>
                            <div class='form-group'>
                                <label>{`${paytype} Account Type `}<tt>*</tt></label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <select
                                            class='form-control custom-form-control'
                                            value={accType}
                                            onChange={(e) => SetAccType(e.target.value)}
                                        >
                                            <option value="">Please Select</option>
                                            <option value="CC">Cash Credit</option>
                                            <option value="OD">Overdraft</option>
                                            <option value="CA">Current</option>
                                            <option value="SA">Savings</option>
                                        </select>
                                    </div>
                                </div>
                                <tt>
                                    {errors && errors?.account_type}
                                </tt>
                            </div>
                            <div class='form-group'>
                                <label>{paytype == "Bank" ? `${paytype} IFSC` : "Customer Bank IFSC"}<tt>*</tt></label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <input
                                            class='form-control custom-form-control'
                                            type='text'
                                            value={ifsc}
                                            onChange={(e) => SetIfsc(e.target.value)}
                                            maxLength={11}
                                        />
                                    </div>
                                </div>
                                <tt>
                                    {errors && errors?.ifsc}
                                </tt>
                            </div>
                            <div class='form-group'>
                                <label>{`${paytype} Disbursal Amount `}<tt>*</tt></label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <input
                                            class='form-control custom-form-control'
                                            value={disbursalAmt}
                                            onChange={(e) => setDisbursalAmt(e.target.value.replace(/[^0-9.]/g, ''))}
                                            maxlength={13}
                                        />
                                    </div>
                                </div>
                                <tt>
                                    {errors && errors?.disbursal_amt}
                                </tt>
                            </div>
                            <div class='d-flex align-items-center justify-content-center mt-3'>
                                <button type='submit' class='btn btn-custom' disabled={loading}>
                                    OK
                                </button>
                                <button
                                    type='button'
                                    class='btn btn-outline-custom ml-2'
                                    data-dismiss='modal'
                                    onClick={toggleModal}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
            <Modal state={showConfirmationModal} closeModal={toggleConfirmationModal} style={{ width: "400px" }} removeBorderSpace={true}>
                <div className="modal-header-container">
                    <div className="modal-title">{`Pay to ${paytype}`}</div>
                    <div className="closeModalView" onClick={toggleConfirmationModal}>
                        <span className="closeModalIcon">x</span>
                    </div>
                </div>
                <div className="p-4">
                    <form onSubmit={handleConfirmationModal}>
                        <div>
                            <div class='form-group'>
                                <label>Please confirm if the details captured are True and you are ready to initiate the Transaction?</label>
                            </div>
                            <div class='d-flex align-items-center justify-content-center mt-3'>
                                <button type='submit' class='btn btn-custom' disabled={loading}>
                                    {loading ? <div className='loader' /> : 'OK'}
                                </button>
                                <button
                                    type='button'
                                    class='btn btn-outline-custom ml-2'
                                    data-dismiss='modal'
                                    onClick={toggleConfirmationModal}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default PayToCustomerModal